/**
 * Extract dynamic route param names from a Next.js Pages Router pathname pattern.
 * Matches optional/catch-all/simple segments: `[param]`, `[...param]`, `[[...param]]`.
 *
 * @param pathname - The Next.js pathname pattern, e.g. `/[locale]/job/list/[[...slug]]`
 * @returns A Set of the param names found in the pattern.
 */
export function extractDynamicRouteParams(pathname: string): Set<string> {
  const paramNames: string[] = [];
  const pattern = /\[+\.{0,3}(\w+)]+/g;
  let match = pattern.exec(pathname);
  while (match !== null) {
    paramNames.push(match[1]);
    match = pattern.exec(pathname);
  }
  return new Set(paramNames);
}
